'use client';

import { c as _c } from "react/compiler-runtime";
import SpinningCD from '@/components/SpinningCD';
import { useAnalytics } from '@/hooks/useAnalytics';
interface SpotifyData {
  currentlyPlaying: {
    name: string;
    album?: {
      name: string;
      images: {
        url: string;
      }[];
    };
    artists?: Array<{
      name: string;
    }>;
    external_urls?: {
      spotify: string;
    };
    preview_url?: string | null;
  };
  isPlaying: boolean;
}
interface SpotifyCurrentlyProps {
  data: SpotifyData;
}
const CD_SIZE = 280;
export default function SpotifyCurrently(t0) {
  const $ = _c(16);
  const {
    data
  } = t0;
  const {
    track
  } = useAnalytics();
  let t1;
  if ($[0] !== data.currentlyPlaying.name || $[1] !== track) {
    t1 = () => {
      track("content_engagement", {
        type: "music_preview",
        details: data.currentlyPlaying.name
      });
    };
    $[0] = data.currentlyPlaying.name;
    $[1] = track;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trackPreviewPlay = t1;
  const t2 = data.isPlaying ? "Listening to" : "Last played";
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="text-xs font-medium text-zinc-500 dark:text-zinc-400">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data.currentlyPlaying.artists) {
    t4 = data.currentlyPlaying.artists?.map(_temp).join(", ") || "Unknown Artist";
    $[5] = data.currentlyPlaying.artists;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = data.currentlyPlaying.album?.images?.[0]?.url;
  let t6;
  if ($[7] !== data.currentlyPlaying.name || $[8] !== data.currentlyPlaying.preview_url || $[9] !== t4 || $[10] !== t5 || $[11] !== trackPreviewPlay) {
    t6 = <SpinningCD inline={true} size={CD_SIZE} title={data.currentlyPlaying.name} artist={t4} albumArt={t5} previewUrl={data.currentlyPlaying.preview_url} onPreviewPlay={trackPreviewPlay} />;
    $[7] = data.currentlyPlaying.name;
    $[8] = data.currentlyPlaying.preview_url;
    $[9] = t4;
    $[10] = t5;
    $[11] = trackPreviewPlay;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="flex flex-col items-start gap-2">{t3}{t6}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(artist) {
  return artist.name;
}